import base from "./base"

async function stablecoinFaucet(address) {
    return await base.httpReq(
        true,
        "post",
        '/faucet/stablecoin',
        null,
        {address}
    )
}

export default {
    stablecoinFaucet
}